import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MALImportModal from './MALImportModal';

const ProfileActions = () => {
  const [showMALImportModal, setShowMALImportModal] = useState(false);

  return (
    <div className="profile-actions-container">
      <h3 className="profile-actions-title">Quick Actions</h3>
      <div className="profile-actions">
        <Link to="/anime" className="action-button discover-button">
          <span className="action-icon" aria-hidden="true"></span>
          Discover Anime
        </Link>
        <Link to="/manga" className="action-button discover-button">
          <span className="action-icon" aria-hidden="true"></span>
          Discover Manga
        </Link>
        <button 
          className="action-button import-button"
          onClick={() => setShowMALImportModal(true)}
        >
          <span className="action-icon" aria-hidden="true"></span>
          Import MAL
        </button>
        <Link to="/characters" className="action-button character-button">
          <span className="action-icon" aria-hidden="true"></span>
          Characters
        </Link>
        <Link to="/settings" className="action-button settings-button">
          <span className="action-icon" aria-hidden="true"></span>
          Settings
        </Link>
      </div>
      
      {showMALImportModal && (
        <MALImportModal 
          onClose={() => setShowMALImportModal(false)}
          onImportComplete={(results) => {
            console.log('Import completed:', results);
            // You might want to refresh user's anime collection here
            setShowMALImportModal(false);
            // If you have a function to refresh data in the parent component,
            // you can call it here or pass it as a prop
          }}
        />
      )}
    </div>
  );
};

export default ProfileActions;